import React from "react";
import PageHeader from "../../PageHeader";
import { ReactComponent as AddIcon } from "../../../images/pageheadingicon/addicon.svg";
import { ReactComponent as SectionIcon } from "../../../images/sectionimage/Section.svg";
import useStyles from "../../../../styles";
import ViewSection from "./ViewSection";
import { toast } from "react-toastify";
import SectionsInBulk from "../../../../BulkCSVFilder/SectionsInBulk.csv"


function Section() {
  const classes = useStyles();

    const handleDownload = () => {
    const link = document.createElement("a");
    link.href = SectionsInBulk;
    link.setAttribute("download", "SectionsInBulk.csv");

    // Append to the document and trigger the download
    document.body.appendChild(link);
    link.click();

    // Check if the download started (link exists in document)
    if (document.body.contains(link)) {
      toast.success("Sample file for adding branches in bulk has been downloaded");
    } else {
      toast.error("Failed to download the bulk branches file. Please try again.");
    }

    // Clean up
    link.parentNode.removeChild(link);
  };
  const Heading = [
    {
      id: 1,
      pageicon:<SectionIcon />,
      mainheading: "Section",
      subhead: "Want to Add in Bulk ?",
      // downloadlink: "Download bulk Sample Files",
      showDownloadButton: true,
      downloadButtonText: "Download bulk Sample Files",
      onDownload: handleDownload,
      addbtntext:"Create New section",
      addbtnicon: <AddIcon />,
      addbtnstyle: "bluebtn",
      path:"/admin/addsection",
    },
  ];
  return (
    <div className={`${classes.p1} ${classes.pb0}`}>
      <PageHeader Heading={Heading}/>
      <ViewSection/>
    </div>
  );
}
export default Section;